import React, { Component } from 'react';
import { observer } from 'mobx-react';

// Import from Style
import {
  Wrapper,
  Label,
  CaptionWrapper,
  Caption,
  ImageWrapper,
  Image,
  MobileImage,
  ZoomedImage,
  ZoomCloseButton,
} from './style';

import AppState from '../../states/AppState';

class EditorialListItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      zoomed: false,
      imageDimensions: this.imageDimensions(),
      zoomedImageDimensions: this.zoomedImageDimensions(),
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleWindowScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleWindowScroll);
  }

  zoomedImageDimensions() {
    const { item } = this.props;

    if (!item.image || !this.thumb) return null;

    const { zoomedImageArea } = AppState;
    const imageWidth = item.image.full.width;
    const imageHeight = item.image.full.height;
    const relativeSize =  Math.sqrt(zoomedImageArea / (imageWidth * imageHeight));

    let height = imageHeight * relativeSize;
    let width = imageWidth * relativeSize;

    if (width * window.devicePixelRatio > imageWidth) {
      width = imageWidth / window.devicePixelRatio;
      height = imageHeight / window.devicePixelRatio;
    }

    if (height * window.devicePixelRatio > imageHeight) {
      height = imageHeight / window.devicePixelRatio;
      width = imageWidth / window.devicePixelRatio;
    }

    if (height > AppState.windowHeight * 1.2) {
      height = AppState.windowHeight * 1.2;
      width = imageWidth / imageHeight * height;
    }

    if (width > AppState.windowWidth * 1.2) {
      width = AppState.windowWidth * 1.2;
      height = imageHeight / imageWidth * width;
    }

    const thumbBox = this.thumb.getBoundingClientRect();
    const scale = thumbBox.width / width * 2;
    const translateX = (AppState.windowWidth / 2) - (thumbBox.left + (thumbBox.width / 2));
    const translateY = (AppState.windowHeight / 2) - (thumbBox.top + (thumbBox.height / 2));

    const margin = `-${height / 2}px -${width / 2}px`;
    const transform = `translate3d(${translateX * -1}px, ${translateY * -1}px, 0) scale(${scale})`;

    return { height, margin, transform, width };
  }

  imageDimensions() {
    const { item } = this.props;

    if (!item.image) return null;

    const { miniThumbnailArea } = AppState;
    const imageWidth = item.image.full.width;
    const imageHeight = item.image.full.height;
    const relativeSize =  Math.sqrt(miniThumbnailArea / (imageWidth * imageHeight));

    let height = imageHeight * relativeSize;
    let width = imageWidth * relativeSize;

    return { height, width };
  }

  handleWindowScroll = () => {
    this.setState({
      zoomedImageDimensions: this.zoomedImageDimensions()
    });
  }

  render() {
    const { item } = this.props;

    return (
      <Wrapper
        onClick={(evt) => {
          evt.preventDefault();
          this.setState({
            zoomed: !this.state.zoomed,
          });
        }}
      >
        <Label>{item.label}</Label>
        <MobileImage src={item.image.full.url} />
        <CaptionWrapper>
          <ImageWrapper
            style={this.state.imageDimensions}
            innerRef={(el) => {
              if (!this.thumb) {
                this.thumb = el;
                this.setState({
                  imageDimensions: this.imageDimensions(),
                  zoomedImageDimensions: this.zoomedImageDimensions(),
                })
              }
            }}
          >
            <Image
              className={this.state.zoomed ? 'inactive' : 'active'}
              src={item.image.full.url}
              height={item.image.full.height}
              width={item.image.full.width}
            />
            <ZoomedImage
              className={this.state.zoomed ? 'active' : 'inactive'}
              src={item.image.full.url}
              height={item.image.full.height}
              width={item.image.full.width}
              style={this.state.zoomedImageDimensions}
            />
          </ImageWrapper>
          <Caption dangerouslySetInnerHTML={{
              __html: item.caption
            }}
          />
        </CaptionWrapper>
        {this.state.zoomed ? (
          <ZoomCloseButton
            onClick={(evt) => {
              evt.preventDefault();
              this.setState({
                zoomed: false,
              });
            }}
          />
         ) : null}
      </Wrapper>
    );
  }
}

export default observer(EditorialListItem);



// WEBPACK FOOTER //
// ./src/components/EditorialListItem/index.js